<template>
	<v-card
		:href='generateVehicleUrl(vehicleURL)'
		class='vehicle-card shadow pa-2'
		:class='{"large-solo" : largeSolo, "advertisement-optic" : hasActiveOpticAdvertisement}'
	>
		<v-row class='px-4 pt-4 ma-0'>
			<div
				class='delivery font-weight-bold mb-2 '
			:class='isInstantAvailable'
			>
				<v-icon size='12' class='mr-1'>
					fas fa-truck
				</v-icon>
				{{ generatedDeliveryText }}
			</div>
		</v-row>
		<v-row class='px-4 ma-0 campaign-box'>
			<div
				v-if='hasActiveAdvertisement'
				class='mr-4 inline-block font-weight-bold campaign-badge'
			>
				<v-icon size='12' class='mr-1'>
					fas fa-rocket
				</v-icon>
				Gesponsert
			</div>
			<div
				class='px-4 pt-2 pb-1 font-weight-bold'
				:class='{"campaign-badge" : sanitizedCampaignHtml}'
				v-html='sanitizedCampaignHtml'
			/>
		</v-row>

		<div style='height: 154px'>
			<v-img
				:src='vehicle.title_image'
				contain
				height='131px'
			>
				<template v-slot:placeholder>
					<v-row
						align='center'
						class='fill-height ma-0'
						justify='center'
					>
						<v-progress-circular
							color='primary lighten-3'
							indeterminate
							width='4'
							size='38'
						/>
					</v-row>
				</template>
			</v-img>
		</div>

		<v-row class='pa-4 pt-0' no-gutters>
			<v-col cols='12' class='text-ellipsis font-weight-bold vehicle-title pt-3'>
				{{ vehicle.model.brand.title }} {{ vehicle.model.title }}
			</v-col>

			<v-col cols='12' class='description text-ellipsis'>
				{{ vehicle.description }}
			</v-col>

			<v-col
				cols='12'
				class='mt-3'
			>
				<v-row
					class='badge-row'
					align='center'
					no-gutters
				>
					<v-col v-if='!vehicle.top_equipped && !vehicle.premium' class='mt-8' />
					<v-col v-if='vehicle.top_equipped' class='flex-grow-0' style='margin-right: 6px'>
						<v-chip
							color='beige'
							title='Dieses Fahrzeug hat eine besonders gute Ausstattung.'
							class='my-1'
						>
							<v-icon size='12' class='mr-1'>
								fas fa-star
							</v-icon>
							Top Ausstattung
						</v-chip>
					</v-col>

					<v-col v-if='vehicle.premium' class='flex-grow-0'>
						<v-chip
							color='beige'
							title='Dies ist ein Premium Fahrzeug.'
							class='my-1'
						>
							<v-icon size='12' class='mr-1'>
								fas fa-gem
							</v-icon>
							Premium Auto
						</v-chip>
					</v-col>
				</v-row>
			</v-col>

			<v-col cols='12' class='mt-3'>
				<v-row align='center' no-gutters>
					<v-col cols='12' class='details'>
						<v-icon style='margin-bottom: 1px'>
							fal fa-car
						</v-icon>
						{{ vehicle.power.hp }} PS |
						{{ getFuel(vehicle.fuel) }} |
						{{ getGearshift(vehicle.gearshift) }}
						<span v-if='getYear(vehicle.first_registration)'>| {{
							getYear(vehicle.first_registration)
						}}</span>
					</v-col>
				</v-row>
			</v-col>


			<v-col cols='12' class='mt-1'>
				<v-row align='center' no-gutters>
					<v-col cols='12' class='details'>
						<v-icon style='margin-left: 2px; margin-bottom: 1px'>
							fal fa-clipboard-list
						</v-icon>
						{{ mileageText }}
					</v-col>
				</v-row>
			</v-col>

			<v-col cols='12' class='mt-1'>
				<v-row align='center' no-gutters>
					<v-col cols='12' class='details'>
						<VehicleCardConsumption v-if="vehicle.consumption.wltp_view" :data="vehicle.consumption"></VehicleCardConsumption>
							<div v-else>
								<v-icon style='margin-bottom: 1px'>
									fal fa-leaf
								</v-icon>{{ vehicle.consumption.combined }}<span v-if='vehicle.fuel.id === 10 || vehicle.fuel.title === "Elektro"'>kWh / 100km (komb.)</span><span v-else>l / 100km (komb.) </span> | {{ vehicle.environment.co2_emmission }}g CO2 / km (komb.) ({{vehicle.efficiency_class}})
							</div>
					</v-col>
				</v-row>
			</v-col>
			<div class='abo-partner-boxed'>
				<b>Abo-Anbieter</b>
				<img v-if='vehicle.subsidiaryLogoUrl' :src='vehicle.subsidiaryLogoUrl' />
				<span v-else>{{vehicle.subsidiaryName}}</span>
			</div>
			<v-col cols='12' class='mt-5'>
				<v-row
					align='center'
					no-gutters
					justify='space-between'
					style='position:relative'
				>
					<div v-if='!$store.isBusinessCustomer && vehicle.has_campaign_prices && isActiveCampaign' class='price font-weight-bold'>
						<span class='old-price'>
							{{ oldPrice }}
						</span>
						<span class='price' style='font-size: 20px; color: #ff0000'>{{ price }}</span> <span>mtl.</span>
					</div>
					<div v-if='$store.isBusinessCustomer && !vehicle.has_campaign_prices'>
						<span class='netto-price-text'>
							Netto
						</span>
						<span class='price font-weight-bold business-price'>{{ price }}</span>
						<span style='font-size: 10px !important; margin-left:6px' class='price font-weight-bold'>mtl.</span>
					</div>
					<div v-if='$store.isBusinessCustomer && vehicle.has_campaign_prices && isActiveCampaign' class='price font-weight-bold'>
						<span class='netto-price-text'>
							Netto <span style='text-decoration: line-through; color: #0064F6'> {{ oldPrice }} </span>
						</span>

						<span class='price' style='font-size: 20px; color: #ff0000'>{{ price }}</span>
						<span style='font-size: 10px !important; margin-left: 6px;' class='price font-weight-bold'>mtl.</span>
					</div>
					<div v-if='!$store.isBusinessCustomer && !isActiveCampaign' :class='["price", "font-weight-bold", "price-"+vehicle.country]'>
						{{ price }} <span class='price font-weight-bold' style='font-size: 10px !important'>mtl.</span>
					</div>
					<v-btn
						color='accent'
						class='details-btn'
						depressed
						tabindex='-1'
						:ripple='false'
					>
						Details
						<v-icon size='13' class='ml-2' tabindex='-1'>
							fas fa-chevron-right
						</v-icon>
					</v-btn>
				</v-row>
			</v-col>

		</v-row>
	</v-card>
</template>

<script>
import utils from '@/libs/utils';
import VehicleCardConsumption from '@/components/VehicleCardConsumption.vue';

export default {
	name: 'VehicleCard',

	components: {VehicleCardConsumption},

	props: {
		vehicle: {
			required: true,
			type: Object
		},
		largeSolo: {
			type: Boolean,
			default: false
		},
    //For Google TagManager
    positionCatalog: {
		  type: Number,
      required: false,
      default: -1
    }
	},

	data() {
		return {
		  oldPrice: '',
			price: undefined,
			mileageText: undefined,
      		cheapestOption: null,
			isActiveCampaign: false
		}
	},

	computed: {
    sanitizedCampaignHtml() {
      const { campaign } = this.vehicle
      if (typeof campaign !== undefined && campaign !== null) {
        const htmlStrings = campaign.split('</style>')
        if (htmlStrings.length > 1) {
          return htmlStrings[1]
        } else if (campaign.length > 0) {
          return campaign
        } else {
          return null
        }
      } else {
        return null
      }
    },

		vehicleURL() {
			return process.env.VUE_APP_BASE_URL + /katalog/ + this.vehicle.slug
		},

    generatedDeliveryText() {
		if(this.vehicle.availability.available_status == 'COMING_SOON') {
			return `Demnächst verfügbar`
		} else if (this.vehicle.availability.available_status == 'NOW_AVAILABLE') {
			return `Sofort verfügbar`
		} else {
			const weeks = parseInt(this.vehicle.availability.delivery_time_after_booking)
			const unit = weeks === 1 ? 'Woche' : 'Wochen'

			return `Verfügbar in ${weeks} ${unit}`
		}
    },

	isInstantAvailable(){
		
		if(this.vehicle.availability.available_status == 'COMING_SOON') {
			return `coming-soon-available`
		} else if (this.vehicle.availability.available_status == 'NOW_AVAILABLE') {
			return 'instant-available'
		} else {
			const weeks = parseInt(this.vehicle.availability.delivery_time_after_booking)
			if(weeks === 1 || weeks === 2) {
				return 'instant-available'
			} else {
				return 'not-instant-available'
			}
		}
    },

    hasActiveOpticAdvertisement() {
      if(this.vehicle.vehicle_advertisements.find(e => e.advertisement.slug === 'highlight_optic')) {
        return true;
      }

      return false;
    },

    hasActiveAdvertisement() {
      return this.vehicle.vehicle_advertisements.length > 0;
    }
	},

  watch: {
	  '$store.isBusinessCustomer': function() {
	    this.getLowestPriceAndMileage();
    }
  },

	mounted() {
		this.getLowestPriceAndMileage()

  },
     methods: {
	 generateVehicleUrl(rawUrl) {
	     let url = rawUrl;
	     if(this.cheapestOption === null) {
	         return url;
       }
       url += '?';
       if(this.cheapestOption.duration_id) {
           url += 'duration='+this.cheapestOption.duration_id;
       }
       url += '&';
       if(this.cheapestOption.mileage_id) {
           url += 'mileage='+this.cheapestOption.mileage_id;
       }
       url += '&showNettoPrice='+this.$store.isBusinessCustomer;
       url += '&FID='+this.vehicle.id;
       url += '&PID='+this.vehicle.subsidiary_id;
	     return url;
         },
	 getGearshift() {
	     if(!this.vehicle.gearshift) {
	         return '-';
             }
	     if (this.vehicle.gearshift.id === 2) {
		 return 'Manuell'
             }
	     return this.vehicle.gearshift.title
	 },

       getFuel() {
         let slug = this.vehicle.fuel.slug
         slug = slug.toLowerCase ()
         if (slug.includes ('hybrid')) {
           return 'Hybrid'
         } else if (slug.includes ('elektro')) {
           return 'Elektro'
         }
         return this.vehicle.fuel.title
       },
	async getLowestPriceAndMileage() {
     const mileageFilter = this.$store.filters.find(f => f.name === 'mileage')
     const durationFilter = this.$store.filters.find(f => f.name === 'minimum_duration')
     let selectedMileage = null;
     let selectedDuration = null;

     let priceField = 'price';
     if(this.vehicle.has_campaign_prices) {
		let isActive = false;

		try {
			const response = await fetch(process.env.VUE_APP_API_ENDPOINT + 'vehicles/is-in-active-campaign/' + this.vehicle.id);
			const data = await response.json();
			isActive = data;
		} catch (error) {
		}

		if(isActive){
			priceField = 'campaign_price'
			this.isActiveCampaign = isActive
		}
     }
     if(this.$store.isBusinessCustomer) {
       priceField += '_without_tax';
     }

     if (mileageFilter.selectedValues && mileageFilter.selectedValues[0] && mileageFilter.selectedValues[0].value > 0) {
        selectedMileage = mileageFilter.selectedValues[0].value
     }
     if (durationFilter.selectedValues && durationFilter.selectedValues[1] && durationFilter.selectedValues[1].value > 0) {
        selectedDuration = durationFilter.selectedValues[1].value
     }

     let cheapestOption = this.vehicle['price_plans'];

     if(selectedDuration !== null) {
       cheapestOption = cheapestOption.filter(item => item.duration_id === selectedDuration);
     }
     if(selectedMileage !== null) {
       cheapestOption = cheapestOption.filter(item => item.mileage_id === selectedMileage);
     }

     cheapestOption = cheapestOption.reduce((prev, curr) => prev[priceField] < curr[priceField] ? prev : curr)

     this.cheapestOption = cheapestOption;
     this.price = new Intl.NumberFormat(utils.countryToLocale(this.vehicle.country), { style: 'currency', currency: utils.countryToCurrency(this.vehicle.country) }).format(cheapestOption[priceField]);
     this.oldPrice = new Intl.NumberFormat(utils.countryToLocale(this.vehicle.country), { style: 'currency', currency: utils.countryToCurrency(this.vehicle.country) }).format(cheapestOption['price']);
     this.mileageText = `bei ${cheapestOption.minimum_duration} ${cheapestOption.duration_id === 1 ? 'Monat' : 'Monaten'} und ${cheapestOption.mileage} km mtl.`

   },
	 getYear(datestr) {
	     if (!datestr) return ''
	     return new Date(datestr).getFullYear()
	 }
     }
}
</script>

<style lang='scss'>

.abo-partner-boxed {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	margin: 20px 0 5px;
	gap: 20px;
	background: #f2f2f2;
	width: 100%;
	border-radius: 7px;
    padding: 12px 15px;

	b {
		font-size: 12px;
	}

	img {
		max-width: 120px;
		max-height: 50px;
		width: 100%;
		mix-blend-mode: darken;
	}
}

.campaign-box {
  height: 48px;
}

.campaign-badge {
  background-color: #efefef;
  font-size: 11px;
  border-radius: 5px;
}

.instant-available {
  background-color: rgba(0, 152, 25, 0.28);
  color: #399600 !important;
  padding: 5px 16px;
  border-radius: 5px;
  i {
    color: #399600 !important;
  }
}

.not-instant-available {
  color: #000 !important;
  padding: 5px 16px;
  border-radius: 5px;
  border: solid 1px #efefef;
  background-color: #efefef;
  i {
    color: #000 !important;
  }
}

.coming-soon-available {
	background-color: #ffa400 !important;
	color: #855704 !important;
	padding: 5px 16px;
	border-radius: 5px;
	border: solid 1px #efefef;
	background-color: #efefef;
	i {
		color: #855704 !important;
	}
}

.old-price {
  position: absolute;
  top: -5px;
  font-weight: normal;
  font-size: 10px;
  color: #02020b;
  text-decoration: line-through;
}
.netto-price-text {
  position: absolute;
  top: -5px;
  font-weight: normal;
  font-size: 10px;
  color: #02020b;
}
.vehicle-card {
	cursor: pointer;
	min-height: 415px !important;

	.delivery {
		font-size: 10px;
		min-height: 24px;
	}

	.vehicle-title {
		font-size: 17px;
	}

	.badge-row {
		min-height: 32px;
		line-height: 32px;
		margin-left: -6px;
		margin-right: -6px;

		.v-chip {
			padding: 0 8px;
			font-size: 11px;
			height: 22px;

			&:hover::before {
				opacity: 0 !important;
			}

			.fa-star {
				margin-bottom: 1px;
			}

			.fa-gem {
				margin-top: 0;
			}
		}
	}

	.description {
		font-size: 14px;
		min-height: 19px;
	}

	.details {
		font-size: 12px;
		margin-left: -2px;
		margin-right: -2px;

		.v-icon {
			margin-right: 6px;
			font-size: 12.7px !important;
		}
	}

  .business-price {
    color: #0064F6 !important;
  }
	.price {
		font-size: 20px;

		span {
			font-size: 10px;
		}
	}
  .price-ch {
    font-size: 13pt;

    span {
      font-size: 10px;
    }
  }
	.details-btn {
		height: 34px !important;
		padding: 0 13px !important;
		font-size: 13px !important;
	}
}

.vehicle-card.large-solo {
  .delivery {
    font-size: 11px !important;
  }
	.badge-row {
		margin-left: -3px;
		margin-right: -3px;

		.v-chip {
			font-size: 13px;
			height: 30px;
			padding: 0 11px;

			.fa-star {
				margin-bottom: 0px;
			}

			.fa-gem {
				margin-top: 0px;
			}
		}
	}


	.vehicle-title {
		font-size: 18px;
	}

	.description {
		font-size: 16px;
	}

	.details {
		font-size: 13px;

		.v-icon {
			font-size: 14px !important;
		}
	}

	.price {
		font-size: 21px;

		span {
			font-size: 11px;
		}
	}

}

.details-btn {
  height: 32px !important;
  padding: 0 16px !important;
  font-size: 14px !important;
  border-radius: 2px !important;
  background-color: #ff0000 !important;
}

.v-chip .v-chip__content{
  font-size: 11px;
}

</style>
